module.exports = __webpack_public_path__ + "static/media/newSS.49c7a3f5.png";